import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { DateUtils } from '../_commons/date-utils';
import { Config } from "../config";
import { ReactivePowerAnalysisInput } from '../_models/reactive-power-analysis-imput';
import { GuiService } from '../_services/gui-service/gui.service';
import { ReactivePowerAnalysisService } from '../_services/reactive-power-analysis-service/reactive-power-analysis.service';
import { InputService } from '../_services/input/input.service';
import { ConfigurationService } from "../_services/configuration/configuration.service";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-reactive-power-analysis-dialog',
  templateUrl: './reactive-power-analysis-dialog.component.html',
  styleUrls: ['./reactive-power-analysis-dialog.component.css']
})
export class ReactivePowerAnalysisDialogComponent implements OnInit {
  private topology: any;

  fromDate: NgbDateStruct;
  toDate: NgbDateStruct;
  ogmEnabled: boolean = false;
  numberOfDay: number;

  public oneDayDatePicker: boolean = false;
  public oneWeekDatePicker: boolean = false;
  public customDatePicker: boolean = true;
  selectDateForm: FormGroup;
  public rpaForecastingIsShown: boolean;
  public forecasting: boolean;

  constructor(public activeModal: NgbActiveModal,
    private reactivePowerAnalysisService: ReactivePowerAnalysisService,
    private guiService: GuiService,
    private inputService: InputService,
    private dateUtils: DateUtils,
    private spinner: NgxSpinnerService,
    private configurationService: ConfigurationService,
    private fb: FormBuilder
  ) {
    //this.topology = this.configurationService.getConfiguration().TOPOLOGY;
    this.topology = JSON.parse(localStorage.getItem("currentTopology"));
    this.selectDateForm = this.fb.group({
      selectedDateOptions: ['3']
    });

    this.rpaForecastingIsShown = this.configurationService.getConfiguration().rpaForecastingIsShown;
  }


  ngOnInit(): void {
    // this.topology = JSON.parse(localStorage.getItem("currentTopology"));
    // this.fromDate = this.inputService.getDefaultDate("fromDateDefault");
    // this.toDate = this.inputService.getDefaultDate("toDateDefault");
  }

  runReactivePowerAnalysis() {
    console.log(this.fromDate);
    console.log(this.toDate);
    let fromDate; let toDate;
    if(this.oneDayDatePicker == true){
      let today = new Date();
      toDate = this.dateUtils.dateStringToString1(parseInt(today.toISOString().slice(0, 4)), parseInt(today.toISOString().slice(5,7)), parseInt(today.toISOString().slice(8,10)));
      console.log("Today year ", toDate);
      let fromDateOneDayInterval = new Date();
      fromDateOneDayInterval.setDate(today.getDate() - 1);
      fromDate = this.dateUtils.dateStringToString1(parseInt(fromDateOneDayInterval.toISOString().slice(0, 4)), parseInt(fromDateOneDayInterval.toISOString().slice(5,7)), parseInt(fromDateOneDayInterval.toISOString().slice(8,10)));
      console.log("yesterday ", fromDate)
    }
    if(this.oneWeekDatePicker == true){
      let today = new Date();
      toDate = this.dateUtils.dateStringToString1(parseInt(today.toISOString().slice(0, 4)), parseInt(today.toISOString().slice(5,7)), parseInt(today.toISOString().slice(8,10)));
      console.log("Today year ", toDate);
      let fromDateOneDayInterval = new Date();
      fromDateOneDayInterval.setDate(today.getDate() - 7);
      fromDate = this.dateUtils.dateStringToString1(parseInt(fromDateOneDayInterval.toISOString().slice(0, 4)), parseInt(fromDateOneDayInterval.toISOString().slice(5,7)), parseInt(fromDateOneDayInterval.toISOString().slice(8,10)));
      console.log("yesterday ", fromDate)
    }
    if(this.customDatePicker == true){
      if (this.fromDate.year && this.fromDate.month && this.fromDate.day &&
        this.toDate && this.toDate.month && this.toDate.day) {
        fromDate = this.dateUtils.dateStringToString1(this.fromDate.year, this.fromDate.month, this.fromDate.day);
        toDate = this.dateUtils.dateStringToString1(this.toDate.year, this.toDate.month, this.toDate.day);
        this.inputService.saveDefaultDate("fromDateDefault", this.fromDate);
        this.inputService.saveDefaultDate("toDateDefault", this.toDate);
        this.numberOfDay = this.inputService.getNumberOfDays(fromDate, toDate);
        this.inputService.saveNumberOfDays('numberOfDayRPA', this.numberOfDay);
      } else {
        return;
      }
    }
    const reactivePowerAnalysisInput: ReactivePowerAnalysisInput = new ReactivePowerAnalysisInput();
    reactivePowerAnalysisInput.topologyId = this.topology.topologyId;
    reactivePowerAnalysisInput.startDate = DateUtils.stringLocalDateToUTC(fromDate);
    reactivePowerAnalysisInput.endDate = DateUtils.stringLocalDateToUTC(toDate);
    reactivePowerAnalysisInput.forecasting = this.forecasting ? true : false;

    console.log(reactivePowerAnalysisInput);


    this.guiService.runReactivePowerAnalysis(reactivePowerAnalysisInput).subscribe(() => {
      this.activeModal.dismiss('reactivePowerAnalysisStarted');

    });
  }

  isReactivePowerAnalysisRunning(): boolean {
    return this.reactivePowerAnalysisService.isReactivePowerAnalysisRunning();
  }

    /**
   * Check selected date range
   * The method return true when the "fromDate" is previous of "toDate",
   * and return false in all other cases
   * @returns Boolean (true/false)
   */
  checkSelectedRangeDate() {
    if(this.oneDayDatePicker == true || this.oneWeekDatePicker == true){
      return false;
    }
    else if (this.fromDate && this.toDate) {
      let fDate = new NgbDate(this.fromDate.year, this.fromDate.month, this.fromDate.day)
      let tDate = new NgbDate(this.toDate.year, this.toDate.month, this.toDate.day)
      if (tDate.after(fDate) || fDate.equals(tDate)) {
        return false;
      }
      else{
        return true;
      }
    }
    else {
      return true;
    }
  }


  checkSelectedDatePicker(): void{
    if(this.selectDateForm.get('selectedDateOptions').value == 1){
      this.oneDayDatePicker = true;
      this.oneWeekDatePicker = false;
      this.customDatePicker = false;
    }else if(this.selectDateForm.get('selectedDateOptions').value == 2){
      this.oneDayDatePicker = false;
      this.oneWeekDatePicker = true;
      this.customDatePicker = false;
    }else if (this.selectDateForm.get('selectedDateOptions').value == 3){
      this.oneDayDatePicker = false;
      this.oneWeekDatePicker = false;
      this.customDatePicker = true;
    }
  }
}
